import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@mui/material';
import VerticalDots from '../../../component/table/img/verticalDots.svg';
import MenuOptionItem from '../../../component/menuOptionItem/MenuOptionItem';
import { sectionRenewLabels } from './maintenanceComplianceFormUtils';
import '../../../component/menuPopup/menu-popup.css';

const MaintenanceComplianceRowActionsMenu = ({
  section,
  menuId,
  disabled = false,
  onRenew,
  onEdit,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const renewLabel = sectionRenewLabels[section] || 'Renew';

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRenew = () => {
    if (disabled) return;
    handleClose();
    onRenew(section);
  };

  const handleEditClick = () => {
    if (disabled) return;
    handleClose();
    onEdit(section);
  };

  return (
    <div className="maintenance-compliance-row-actions">
      <button
        type="button"
        className="maintenance-compliance-row-menu-btn"
        aria-label={`Edit or ${renewLabel.toLowerCase()} ${section}`}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        aria-controls={anchorEl ? menuId : undefined}
        onClick={handleOpen}
        disabled={disabled}
      >
        <img loading="lazy" src={VerticalDots} alt="" className="maintenance-compliance-row-menu-icon" />
      </button>
      <Popover
        id={menuId}
        sx={{
          boxShadow: 2,
          borderRadius: 3,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <div className="menupopup-container">
          <MenuOptionItem
            label="Edit"
            menuButtonClicked={handleEditClick}
            disable={disabled}
            bottomBorder
          />
          <MenuOptionItem
            label={renewLabel}
            menuButtonClicked={handleRenew}
            disable={disabled}
            bottomBorder={false}
          />
        </div>
      </Popover>
    </div>
  );
};

MaintenanceComplianceRowActionsMenu.propTypes = {
  section: PropTypes.oneOf(['roadTax', 'puspakom', 'insurance']).isRequired,
  menuId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onRenew: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default MaintenanceComplianceRowActionsMenu;
